import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c3296c86&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c3296c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3296c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3296c86')) {
      api.createRecord('c3296c86', component.options)
    } else {
      api.reload('c3296c86', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c3296c86&scoped=true&", function () {
      api.rerender('c3296c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ClVeeerS0W6F/JS/comp/SearchFilterTokens.vue"
export default component.exports